import { Component, Input } from "@angular/core"
import { NotificationsService } from "angular2-notifications"
import { UserService } from "../../../services/user.service"
import Utils from "../../../utils/utils"
import { ModalRef } from "../../modal/modal-ref"

@Component({
    selector: "app-leave-roster-modal",
    templateUrl: "./leave-roster-modal.component.html",
    styleUrls: ["./leave-roster-modal.component.scss"],
})
export class LeaveRosterModalComponent {
    @Input() public classDetails = ""
    @Input() public roster = null

    constructor(
        public activeModal: ModalRef,
        private userService: UserService,
        private notificationService: NotificationsService
    ) {}

    public leaveClass() {
        if (!this.roster.student_id) {
            this.notificationService.error(
                "Uh oh!",
                "Please go to the Teacher View to delete this class.",
                Utils.alertConfiguration
            )
            return
        }
        this.userService.leaveClass(this.roster.id, this.roster.student_id).subscribe(
            (response) => {
                // TODO: better refresh
                window.location.href = "/student"
            },
            (error) => {
                this.notificationService.error(
                    "Uh oh!",
                    "Could remove you from the class.",
                    Utils.alertConfiguration
                )
            }
        )
    }
}
